module.exports = __webpack_public_path__ + "img/3_m.72596641.jpg";